import * as React from 'react';

import "./save-buttons.scss";

import {cs}            from "@Common/react/chain-services";
import {Button}        from "@Common/tools/cc-integration/ui/button/button";
import {BubbleNoti}    from "@Common/ui-components/bubble-noti/bubble-noti";
import {ConfirmDialog} from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";

export const SaveButtons = (
    {
        submitting, buttonClicked, saveConfirmedAlert, disableSaves,
        onDone, isApprovalAfterProof, isComponent,
        editor,
    }
) => cs(
    ["noti", (_, next) => BubbleNoti({next})],
    ["dialogConfirmMergeFieldError", (_, next) => ConfirmDialog({next})],
    ({noti, dialogConfirmMergeFieldError}) => <>
        <div className="save-buttons-5dk">
            <Button
                buttonText={<><i className="fa fa-check"/> Save</>}
                xdQaName="Save"
                disabled={disableSaves.value}
                className="saveButton"
                onClick={async () => {
                    saveConfirmedAlert.onChange(null);
                    disableSaves.onChange(true);

                    if (editor.changed) {
                        submitting.onChange(true);
                        buttonClicked.onChange("save");

                        try {
                            const response = await editor.save({final: false});
                            if (response) {
                                saveConfirmedAlert.onChange({
                                    heading: "CHANGES SAVED",
                                    message: "All of your changes have been saved",
                                    success: true,
                                });
                            } else {
                                saveConfirmedAlert.onChange({
                                    heading: "SAVE INCOMPLETE",
                                    message: "Saving has not been completed. " +
                                        "Please check your internet connection and Save again",
                                    success: false,
                                });
                            }
                        } finally {
                            submitting.onChange(false);
                        }
                    } else {
                        saveConfirmedAlert.onChange({
                            heading: "CHANGES SAVED",
                            message: "All of your changes have been saved.",
                            success: true,
                        });
                    }
                    disableSaves.onChange(false);
                }}
            />
            <Button
                buttonText={<>
                    <i className="fa fa-check"/>
                    {isApprovalAfterProof ? (
                        'Submit for Approval'
                    ) : isComponent ? (
                        'Save & Return to Kit Options'
                    ) : (
                        'Save & Checkout'
                    )}
                </>}
                xdQaName={isApprovalAfterProof ? (
                    'Submit for Approval'
                ) : isComponent ? (
                    'Save & Return to Kit Options'
                ) : (
                    'Save & Checkout'
                )}
                disabled={disableSaves.value}
                className="saveButton"
                onClick={async () => {
                    disableSaves.onChange(true);
                    submitting.onChange(true);
                    buttonClicked.onChange("saveCheckout");
                    if (editor.hasRequiredError){
                        noti.show({message: "Please complete required field(s)"});
                        submitting.onChange(false);
                        disableSaves.onChange(false);
                        return;
                    } else {
                        const errorMessages = await editor.getErrorMessages();

                        if (errorMessages?.length) {
                            if (await dialogConfirmMergeFieldError.show({
                                message: "Merge Field Error",
                                actionContent: errorMessages[0],
                                buttons: {
                                    confirmLabel: "Return to Fix",
                                    cancelLabel: "Ignore and Continue"
                                },
                                passiveCloseResponse: true,
                            })) {
                                submitting.onChange(false);
                                disableSaves.onChange(false);
                                return;
                            }
                        }

                        const saved = await editor.save({final: true});

                        if (!saved) {
                            noti.show({message: "Saving failed, please wait and try again. " +
                                "If issue continues, call for support."});
                            submitting.onChange(false);
                            disableSaves.onChange(false);
                            return;
                        } else {
                            await onDone();
                        }
                    }
                    submitting.onChange(false);
                    disableSaves.onChange(false);
                }}
            />
        </div>
    </>,
);
